import axios from "axios";

const DefaultAxios = axios.create({
  // baseURL: "http://localhost:8008/api"
});

export {
  DefaultAxios,
};
